import {Component, OnInit} from '@angular/core';
import {LocaisService} from "./locais.service";
import {LocaisModel} from "./locais.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";

declare let swal: any;

@Component({
  selector: 'app-locais',
  templateUrl: './locais.component.html'
})
export class LocaisComponent extends Components implements OnInit {

  locais: LocaisModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    private locaisService: LocaisService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'locais'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    /*this.locaisService.getPaginacao(1, this.itensPorPagina, ['pais'])
      .subscribe(data => {
        this.locais = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.locais);
        }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });*/

    this.getPage(1);


  }

  delete(local) {
    let locais = this.locais;
    let locaisService = this.locaisService;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarLocal')+local.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(this.global.debug == true){
          console.log(locais);
        }

        let index = locais.indexOf(local);
        locais.splice(index, 1);

        locaisService.apagar(local.id_local)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              this.locais = locais;
            },
            err => {
              // Revert the view back to its original state
              locais.splice(index, 0, local);
              this.locais = locais;

              this.func.showErro(err.json());
            });

      });

  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.locaisService.getPaginacao(pagina, this.itensPorPagina, ['pais'])
      .subscribe(data => {
        this.locais = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/locais/locais.component.ts